// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EWw6","left":"styles_left__1KtAS"};